export default "__VITE_ASSET__033a416e__"